const LAST_SELECTED_LANG_STORAGE_KEY = "LastLoginLang";
const LAST_LOGIN_USERNAME_STORAGE_KEY = "LastLoginUser";

/**
 * Umožňuje ukládat a načítat data do/z lokálního úložiště
 * !!! Tyto informace jsou platné je pro přihlašovací stránku a nesmí být použity jinde v aplikaci !!!
 */
export class LoginStorage {
    public static getLastSelectedLoginLang(): string | null {
        return localStorage.getItem(LAST_SELECTED_LANG_STORAGE_KEY);
    }

    public static setLastSelectedLoginLang(lang: string): void {
        localStorage.setItem(LAST_SELECTED_LANG_STORAGE_KEY, lang);
    }

    public static getLastLoginUsername(): string | null {
        return localStorage.getItem(LAST_LOGIN_USERNAME_STORAGE_KEY);
    }

    public static setLastLoginUsername(username: string): void {
        localStorage.setItem(LAST_LOGIN_USERNAME_STORAGE_KEY, username);
    }
}
